import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children, adminOnly = false, adminOrPermanentOnly = false, adminOnlyForEdit = false, consultationRestricted = false, editRoute = false }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'administrateur') {
    return <Navigate to="/dashboard" replace />;
  }
  
  if (adminOrPermanentOnly && user.role !== 'administrateur' && !user.isPermanent) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Nouvelle condition pour restreindre l'édition aux administrateurs uniquement
  if (adminOnlyForEdit && user.role !== 'administrateur') {
    return <Navigate to="/users" replace />;
  }
  
  // Le rôle consultation peut maintenant accéder aux pages en lecture seule
  console.log("PrivateRoute - Accès pour:", user.role, "- Route d'édition:", editRoute);
  
  // Le rôle consultation a maintenant accès à toutes les pages en lecture seule
  // Suppression de la restriction pour le rôle consultation
  console.log("PrivateRoute - Accès autorisé pour le rôle:", user.role, "- Page avec consultationRestricted:", consultationRestricted);

  return children;
};

export default PrivateRoute;